/**
 * カスタムセレクトドロップダウンの初期化
 */
const main = () => {
    if (document.querySelector(".c-forms-select") === null) return;

    document.querySelectorAll(".c-forms-select").forEach((root) => {
        // disabled状態はスキップ
        if (root.hasAttribute("data-disabled")) return;

        const trigger = root.querySelector(".c-forms-select__trigger");
        const label = root.querySelector(".c-forms-select__label");
        const nativeSelect = root.querySelector(".c-forms-select__native");
        const options = root.querySelectorAll(".c-forms-select__option");

        // トリガークリックで開閉
        trigger.addEventListener("click", () => {
            const isOpen = root.hasAttribute("data-open");
            // 他のセレクトを閉じる
            document
                .querySelectorAll(".c-forms-select[data-open]")
                .forEach((el) => {
                    if (el !== root) el.removeAttribute("data-open");
                });
            if (isOpen) {
                root.removeAttribute("data-open");
            } else {
                root.setAttribute("data-open", "");
            }
        });

        // カスタムUIをnative selectの値に同期する
        const syncUI = () => {
            const value = nativeSelect.value;
            const matchOption = Array.from(options).find(
                (o) => o.getAttribute("data-value") === value,
            );

            if (matchOption) {
                label.textContent = matchOption.querySelector(
                    ".c-forms-select__option-text",
                ).textContent;
                options.forEach((o) => o.removeAttribute("data-selected"));
                matchOption.setAttribute("data-selected", "");
            }

            if (value === "") {
                root.setAttribute("data-no-value", "");
            } else {
                root.removeAttribute("data-no-value");
            }
        };

        // 外部からnative selectの値が変更された場合にUIを同期
        nativeSelect.addEventListener("change", () => {
            syncUI();
        });

        // オプション選択
        options.forEach((option) => {
            option.addEventListener("click", () => {
                const value = option.getAttribute("data-value");

                // hidden selectの値を更新してchangeイベントを発火
                nativeSelect.value = value;
                nativeSelect.dispatchEvent(
                    new Event("change", { bubbles: true }),
                );

                // ドロップダウンを閉じる
                root.removeAttribute("data-open");
            });
        });
    });

    // 外側クリックで閉じる
    document.addEventListener("click", (e) => {
        if (!e.target.closest(".c-forms-select")) {
            document
                .querySelectorAll(".c-forms-select[data-open]")
                .forEach((el) => {
                    el.removeAttribute("data-open");
                });
        }
    });
};

export default main;
